<template>
    <div class="table-container apprentice-simple-card">
        <div class="table-responsive">
            <table
                class="table b-table apprentice-data-table table-striped table-hover page-access-rights-table"
                role="table">
                <thead role="rowgroup">
                    <tr role="row">
                        <th
                            aria-colindex="1"
                            role="columnheader"
                            scope="col"
                            tabindex="0">
                            <div>{{ $t('magazine.editor') }} / {{ $t('magazine.page') }}</div>
                        </th>
                        <th
                            v-for="page in pages"
                            aria-colindex="2"
                            role="columnheader"
                            scope="col"
                            tabindex="0">
                            {{ page.order }}
                        </th>
                        <th
                            aria-colindex="3"
                            role="columnheader"
                            scope="col"
                            tabindex="0">
                            <div>{{ $t('magazine.everything_none') }}</div>
                        </th>
                    </tr>
                </thead>
                <tbody role="rowgroup">
                    <tr
                        v-for="(user, index) in users"
                        v-if="user.pivot.role != 1"
                        :aria-rowindex="index + 1"
                        role="row">
                        <th>
                            <div class="name">
                                {{ user.full_name }}
                            </div>
                        </th>
                        <td
                            v-for="(page, index) in pages"
                            :aria-colindex="index + 1"
                            :data-label="$t('magazine.page')"
                            role="cell">
                            <div class="page-select apprentice-checkbox custom-control custom-checkbox">
                                <input
                                    class="custom-control-input"
                                    :checked="user.pages[page.id]"
                                    type="checkbox"
                                    value="1"
                                    @change="
                                        onChange({ user_id: user.id, page_id: page.id, right: $event.target.checked })
                                    " />
                                <label class="custom-control-label"></label>
                            </div>
                        </td>
                        <td>
                            <div class="check-all apprentice-checkbox custom-control custom-checkbox">
                                <input
                                    class="custom-control-input"
                                    type="checkbox"
                                    value="1"
                                    @change="onChange({ user_id: user.id, right: $event.target.checked })" />
                                <label class="custom-control-label"></label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-page-rights-component',
    props: ['pagesIn', 'usersIn', 'magazineId'],
    data() {
        return {
            pages: this.pagesIn.map((page) => {
                page.isFirstPage = page.order === 1;
                return page;
            }),
            users: this.usersIn.map((user) => {
                user.pages = {};
                for (const page of this.pagesIn) {
                    user.pages[page.id] = 0;
                    for (const right of page.rights) {
                        if (right.user_id === user.id) {
                            user.pages[page.id] = 1;
                            break;
                        }
                    }
                }
                return user;
            }),
        };
    },
    methods: {
        onChange(data) {
            this.axios.post(this.routes.magazineSetPageRight(this.magazineId), data).then(
                (response) => {
                    if (!data.page_id) {
                        if (data.right) {
                            this.users = this.users.map((user) => {
                                if (user.id === data.user_id) {
                                    for (let n in user.pages) {
                                        if (!user.pages.hasOwnProperty(n)) {
                                            continue;
                                        }
                                        user.pages[n] = 1;
                                    }
                                    user.pages = Object.assign({}, user.pages);
                                    user = Object.assign({}, user);
                                }
                                return user;
                            });

                            for (let j = 0; j < this.pages.length; j++) {
                                let found = false;
                                for (let i = 0; i < this.pages[j].rights.length; i++) {
                                    if (this.pages[j].rights[i].user_id == data.user_id) {
                                        found = true;
                                    }
                                }

                                if (!found) {
                                    this.pages[j].rights.push({ page_id: this.pages[j].id, user_id: data.user_id });
                                    this.pages = this.pages.slice();
                                }
                            }
                        } else {
                            this.users = this.users.map((user) => {
                                if (user.id === data.user_id) {
                                    for (let n in user.pages) {
                                        if (!user.pages.hasOwnProperty(n)) {
                                            continue;
                                        }
                                        user.pages[n] = 0;
                                    }
                                    user.pages = Object.assign({}, user.pages);
                                    user = Object.assign({}, user);
                                }
                                return user;
                            });

                            for (let j = 0; j < this.pages.length; j++) {
                                for (let i = 0; i < this.pages[j].rights.length; i++) {
                                    if (this.pages[j].rights[i].user_id == data.user_id) {
                                        this.pages[j].rights.splice(i, 1);
                                        this.pages = this.pages.slice();
                                    }
                                }
                            }
                        }
                    } else {
                        if (data.right) {
                            for (let j = 0; j < this.pages.length; j++) {
                                if (this.pages[j].id == data.page_id) {
                                    let found = false;
                                    for (let i = 0; i < this.pages[j].rights.length; i++) {
                                        if (this.pages[j].rights[i].user_id == data.user_id) {
                                            found = true;
                                        }
                                    }

                                    if (!found) {
                                        this.pages[j].rights.push({
                                            page_id: this.pages[j].id,
                                            user_id: data.user_id,
                                        });
                                        this.pages[j].rights = this.pages[j].rights.slice();
                                        this.pages = this.pages.slice();
                                    }
                                }
                            }
                        } else {
                            for (let j = 0; j < this.pages.length; j++) {
                                if (this.pages[j].id == data.page_id) {
                                    for (let i = 0; i < this.pages[j].rights.length; i++) {
                                        if (this.pages[j].rights[i].user_id == data.user_id) {
                                            this.pages[j].rights.splice(i, 1);
                                            this.pages = this.pages.slice();
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        hasFound(user_id, rights) {
            for (let i = 0; i < rights.length; i++) {
                if (rights[i].user_id == user_id) {
                    return 1;
                }
            }

            return 0;
        },
    },
};
</script>

<style scoped lang="scss">
.table-responsive {
    width: 100%;
    height: calc(100vh - 270px);
    overflow: auto;
    position: relative;
}

.page-access-rights-table {
    thead {
        th {
            top: 0;
            z-index: 2;
            background-color: $white;
            position: sticky;
            vertical-align: middle;
            line-height: 1;
            text-align: center;
            padding: map-get($grid-gutter-spacing, 'ten');
            white-space: nowrap;

            &:first-child {
                background-color: $primary;
                color: $white;
                position: sticky;
                left: 0;
                z-index: 5;
                border-right: 1px solid $white;
            }
        }
    }

    tbody {
        tr {
            &:hover,
            &:nth-of-type(odd) {
                background-color: $secondary-background-color;
            }
        }

        th {
            &:first-child {
                background-color: $primary;
                color: $white;
                position: sticky;
                left: 0;
                z-index: 2;
                border-right: 1px solid $white;
                white-space: nowrap;
            }
        }

        th,
        td {
            vertical-align: middle;
        }

        td {
            .custom-control {
                text-align: center;
                padding-left: 0;
                min-width: 20px;

                input {
                    position: relative;
                    width: auto;

                    &[type='checkbox'] {
                        left: 2px;
                    }
                }

                &:hover {
                    cursor: default;
                }
            }
        }
    }
}

div.page-select:hover {
    cursor: default;
}

div.page-select ::v-deep,
div.check-all ::v-deep {
    input[type='checkbox'] {
        z-index: 8;

        & + .custom-control-label {
            position: relative;
            left: -18px;
            vertical-align: top;

            &:before {
                margin-right: 0;
                left: 1px;
            }
        }

        &:hover {
            cursor: pointer;
        }
    }
}
</style>
